<script>
  import boxComponent from './box/box.vue';

  export default {
    data() {
      return {
        isHidden: true,
        isPrintedLoading: false,
      };
    },
    props: ['shipment'],
    components: {
      box_component: boxComponent,
    },
    filters: {
      setLabelName(name) {
        if (!name) return name;
        let sliced = name.slice(0, 15);
        if (name !== sliced) sliced += '...';
        return sliced;
      },
    },
  };
</script>
<template src="./shipment.pug" lang="pug"></template>
